import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  showModalAssignOutlets,
  hideModalConfirmAssignOutlets,
} from 'actions/setting/bankAccount';
import { arrayPush, arrayRemoveAll, getFormValues, reset } from 'redux-form';
import styles from './style.css';

class ConfirmAssignOutletsModal extends React.Component {
  render() {
    const { showModalConfirmAssignOutlets, bankAccountForm } = this.props;

    return (
      <Modal
        show={showModalConfirmAssignOutlets}
        className={`${styles.modal}`}
        dialogClassName={`modal-dialog ${styles['modal-dialog']}`}
      >
        <Modal.Header>
          <Modal.Title>
            <span className="pull-left">Assignment Confirmation</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            You have selected several outlets that will be moved from their
            current bank account
            {bankAccountForm.bankName !== undefined &&
              bankAccountForm.accountNumber !== undefined && (
                <span>
                  {' '}
                  to{' '}
                  <strong>
                    {bankAccountForm.bankName} - {bankAccountForm.accountNumber}
                  </strong>
                </span>
              )}
            . Do you want to proceed?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <button
            className={`btn mr-10px ${styles['btn-outline-dark']} ${
              styles['btn-large']
            }`}
            type="button"
            onClick={this._onClickCancel}
          >
            Cancel
          </button>
          <button
            className={`btn btn-primary ${styles['btn-large']}`}
            onClick={this._onClickProceed}
          >
            Proceed
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  _onClickCancel = e => {
    this.props.dispatch(hideModalConfirmAssignOutlets());
    this.props.dispatch(showModalAssignOutlets());
    e.preventDefault();
    e.stopPropagation();
  };

  _onClickProceed = e => {
    const { availableOutlets, assignOutletsForm } = this.props;

    this.props.dispatch(arrayRemoveAll('bankAccountForm', 'newOutlets'));
    availableOutlets
      .filter(
        availableOutlet =>
          assignOutletsForm.outlets[availableOutlet.id].selected
      )
      .forEach(availableOutlet => {
        this.props.dispatch(
          arrayPush('bankAccountForm', 'newOutlets', availableOutlet)
        );
      });

    this.props.dispatch(reset('assignOutletsForm'));
    this.props.dispatch(hideModalConfirmAssignOutlets());

    e.preventDefault();
    e.stopPropagation();
  };
}

function mapStateToProps(state) {
  const {
    showModalConfirmAssignOutlets,
    availableOutlets,
  } = state.setting.bankAccount;

  return {
    showModalConfirmAssignOutlets,
    availableOutlets,
    assignOutletsForm: getFormValues('assignOutletsForm')(state),
    bankAccountForm: getFormValues('bankAccountForm')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmAssignOutletsModal);
